import React, { useMemo } from 'react';
import { CTitle, STitle } from '../../components/Widget';
import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
import ArrowImg from '../../../../../../assets/2025/arrow.gif';
import Icon1 from '../../../../../../assets/finance/topic1600/icon1.png';
import Icon2 from '../../../../../../assets/finance/topic1600/icon2.png';
import Icon3 from '../../../../../../assets/finance/topic1600/icon3.png';
import Icon4 from '../../../../../../assets/finance/topic1600/icon4.png';
import Icon5 from '../../../../../../assets/finance/topic1600/icon5.png';

import section2Bg5 from '../../../../../../assets/finance/topic1600/section2-bg5.png';

interface ISection0Props {
  settings: any;
}

const Section2: React.FunctionComponent<ISection0Props> = ({ settings }) => {
  const ID = '3';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[2],
    [settings?.paragraphs]
  );
  const updateComponentState = useUpdateComponentState();
  const [state, setState] = React.useState({
    play: 1,
    isPlayed: false,
  });

  // State for internal threats animation
  const [internalThreatsState, setInternalThreatsState] = React.useState({
    visibleCount: 1,
    animationStarted: false,
  });

  const [isShowArrowImg, setIsShowArrowImg] = React.useState(true);
  const startPlay = (next = 1) => {
    if (state.isPlayed) {
      return;
    }
    next += 1;
    setState({ play: next, isPlayed: true });
    if (next <= 5) {
      setTimeout(() => startPlay(next), 1000);
    }
    updateComponentState(p_course, p_topic, ID, 'finance-topic1600-section2-1');
  };

  // Start internal threats animation
  const startInternalThreatsAnimation = () => {
    if (!internalThreatsState.animationStarted) {
      setIsShowArrowImg(false);
      setInternalThreatsState((prev) => ({
        ...prev,
        animationStarted: true,
      }));
      updateComponentState(
        p_course,
        p_topic,
        ID,
        'finance-topic1600-section2-2'
      );
    }
  };

  const noToImg = (no: '01' | '02' | '03' | '04' | '05'): string => {
    const imgMap: Record<'01' | '02' | '03' | '04' | '05', string> = {
      '01': Icon1,
      '02': Icon2,
      '03': Icon3,
      '04': Icon4,
      '05': Icon5,
    };
    return imgMap[no];
  };

  React.useEffect(() => {
    if (!internalThreatsState.animationStarted) return;

    const totalItems = paragraphsSettings?.l2List?.length || 0;
    if (internalThreatsState.visibleCount >= totalItems) return;

    const timer = setTimeout(() => {
      setInternalThreatsState((prev) => ({
        ...prev,
        visibleCount: prev.visibleCount + 1,
      }));
    }, 600); // 600ms delay between items

    return () => clearTimeout(timer);
  }, [
    internalThreatsState.visibleCount,
    internalThreatsState.animationStarted,
    paragraphsSettings?.l2List?.length,
  ]);
  return (
    <div className="topic-section-2">
      <CTitle title={paragraphsSettings?.title} />
      <div>
        <STitle title={paragraphsSettings?.subTitle} />
      </div>
      <div id="finance-topic1600-section2-1" className="attentions-container">
        <div className="content" onClick={() => startPlay()}>
          <div
            className="tip"
            dangerouslySetInnerHTML={{ __html: paragraphsSettings?.l1 }}
          />
          <div
            className="arrow"
            style={{ display: state.isPlayed ? 'none' : 'block' }}
          >
            <img src={ArrowImg} alt="" />
          </div>
          <div className="item-wrap">
            {paragraphsSettings?.l1List?.map(
              (item: { no: string; desc: string }, index: number) => (
                <div
                  key={item.no}
                  className={`attention-item ${
                    state.play > index + 1 ? 'fade-in' : ''
                  }`}
                >
                  <div className="item-no">
                    <img
                      src={noToImg(item.no as '01' | '02' | '03' | '04' | '05')}
                      alt=""
                    />
                  </div>
                  <div className="item-desc">{item.desc}</div>
                </div>
              )
            )}
          </div>
        </div>
      </div>

      <div className="internal-threats" id="finance-topic1600-section2-2">
        <div>
          <STitle title={paragraphsSettings?.l2} />
        </div>
        {isShowArrowImg && (
          <div className="arrow">
            <img src={ArrowImg} alt="" />
          </div>
        )}
        <div className="internal-threats-content">
          <div className="internal-threats-left">
            {paragraphsSettings?.l2List?.map((item: any, index: number) => (
              <div
                key={index}
                className={`item ${
                  index < internalThreatsState.visibleCount
                    ? 'visible'
                    : 'hidden'
                }`}
                onClick={
                  index === 0 ? startInternalThreatsAnimation : undefined
                }
                style={{
                  cursor:
                    index === 0 && internalThreatsState.visibleCount === 1
                      ? 'pointer'
                      : 'default',
                  opacity: index < internalThreatsState.visibleCount ? 1 : 0,
                  transform:
                    index < internalThreatsState.visibleCount
                      ? 'translateY(0)'
                      : 'translateY(20px)',
                  transition:
                    'opacity 0.5s ease-in-out, transform 0.5s ease-in-out',
                }}
              >
                <div className="item-no">{item.no}</div>
                <div className="item-desc">{item.desc}</div>
              </div>
            ))}
          </div>
          <div className="internal-threats-right">
            <div className="chat-con">{paragraphsSettings?.l2Chat}</div>
            <div className="chat-img">
              <img src={section2Bg5} alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Section2);
